import { api } from "../lib";

export type AccessioningPanelOptionType = "panel" | "reflex";

export interface AccessioningPanelComponent {
  id: string;
  stainId: string;
  stainCode: string;
  stainDescription: string;
  quantity: number;
}

export interface AccessioningPanelOption {
  id: string;
  optionType: AccessioningPanelOptionType;
  name: string;
  description: string | null;
  panelDefinitionId: string;
  panelDefinitionVersionId: string;
  panelName: string;
  components: AccessioningPanelComponent[];
}

export interface AccessioningPanelSelection {
  selectionKey: string;
  optionType: AccessioningPanelOptionType;
  optionId: string;
  panelDefinitionId: string;
  panelDefinitionVersionId: string;
}

export const accessioningPanelsService = {
  listOptions: () =>
    api.get<AccessioningPanelOption[]>("/workflows/accessioning/panel-options"),
};
